// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ConsentError__wrapper__1W8lc","contentWrap":"ConsentError__contentWrap__3twj4"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConsentError/ConsentError.css
// module id = 3173
// module chunks = 0